import { $$ } from '../../helpers/shortcuts';
import { Accordion } from '../accordion/Accordion.class';
import { mediaDown } from '../../helpers/media-queries';

function initializeAccordions() {
  initializeDefaultAccordions();
  initializeFooterAccordions();
  initializeResponsiveAccordions();
}

function initializeDefaultAccordions() {
  const accordionNodes = [...$$('.accordion')];

  const manualAccordionNodes = accordionNodes.filter((accordionNode) =>
    accordionNode.classList.contains('accordion-isclosed'),
  );
  [...manualAccordionNodes].map(
    (accordionNode) => new Accordion(accordionNode),
  );

  const automatedAccordionNodes = accordionNodes.filter(
    (accordionNode) => !accordionNode.classList.contains('accordion-isclosed'),
  );
  const automatedAccordions = [...automatedAccordionNodes].map(
    (accordionNode) =>
      new Accordion(accordionNode, {
        toggleCallback: function () {
          const index = automatedAccordions.indexOf(this);
          if (index !== -1) {
            automatedAccordions.splice(index, 1);
          }
        },
      }),
  );

  if (automatedAccordions) {
    mediaDown('large', ({ matches }) => {
      // show / hide in mobile viewports
      if (matches) {
        automatedAccordions.forEach((accordion) => accordion.instantClose());
      } else {
        automatedAccordions.forEach((accordion) => accordion.instantOpen());
      }
    });
  }
}

function initializeFooterAccordions() {
  let accordions;
  mediaDown('medium', ({ matches }) => {
    accordions && accordions.forEach((accordion) => accordion.destroy());
    // only initialize in mobile viewports
    if (matches) {
      accordions = [...$$('.footer-accordion')].map((accordionNode) => {
        const accordion = new Accordion(accordionNode);
        accordion.instantClose();
        return accordion;
      });
    } else {
      accordions &&
        accordions.forEach((accordion) => {
          accordion.destroy();
        });
    }
  });
}

function initializeResponsiveAccordions() {
  let accordions;
  mediaDown('large', ({ matches }) => {
    accordions && accordions.forEach((accordion) => accordion.destroy());
    // only initialize in mobile viewports
    if (matches) {
      accordions = [...$$('.responsiveaccordion')].map((accordionNode) => {
        const accordion = new Accordion(accordionNode);
        return accordion;
      });
    } else {
      accordions &&
        accordions.forEach((accordion) => {
          accordion.destroy();
        });
    }
  });
}

export { initializeAccordions };
